module.exports = __webpack_public_path__ + "img/sweden_ro.06ff3fb3.png";